import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/shared/services';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {

  constructor(private userService: UserService) { }
    isAdmin: boolean;
    isSponsor: boolean;
    isLoggedIn: boolean;

  ngOnInit() {
    this.isAdmin = this.userService.isUserAdmin();
    this.isSponsor = this.userService.isUserSponsor();
    this.isLoggedIn = this.userService.isLoggedIn();
  }

}
